module.exports = __webpack_public_path__ + "img/blue.4c639857.svg";